import React, { useState } from 'react';
import './App.css';
import { useAuth } from './AuthContext';
import LoginPage from './LoginPage';
import BulkImportPage from './BulkImportPage';
import ExportPage from './ExportPage';
import AdminDataManagementPage from './AdminDataManagementPage';
import DuplicatedPage from './DuplicatedPage';

function App() {
  const [currentPage, setCurrentPage] = useState('import');
  const { currentUser, userRole, userClientId, logout } = useAuth();

  // Show login page if user is not authenticated
  if (!currentUser) {
    return <LoginPage />;
  }

  return (
    <div>
      <nav style={{ 
        backgroundColor: '#f8f9fa', 
        padding: '12px 24px', 
        borderBottom: '1px solid #dee2e6',
        marginBottom: '20px'
      }}>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <h1 style={{ margin: 0, fontSize: '24px', color: '#495057' }}>Items Management</h1>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '12px', alignItems: 'center' }}>
            <span style={{ color: '#6c757d', fontSize: '14px' }}>
              Welcome, {currentUser.email} ({userRole === 'admin' ? 'Admin' : 'User'})
            </span>
            <button
              onClick={() => setCurrentPage('import')}
              style={{
                padding: '8px 16px',
                border: '1px solid #007bff',
                backgroundColor: currentPage === 'import' ? '#007bff' : 'white',
                color: currentPage === 'import' ? 'white' : '#007bff',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Import Data
            </button>
            <button
              onClick={() => setCurrentPage('duplicated')}
              style={{
                padding: '8px 16px',
                border: '1px solid #6f42c1',
                backgroundColor: currentPage === 'duplicated' ? '#6f42c1' : 'white',
                color: currentPage === 'duplicated' ? 'white' : '#6f42c1',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Duplicated
            </button>
            {userRole === 'admin' && (
              <>
                <button
                  onClick={() => setCurrentPage('export')}
                  style={{
                    padding: '8px 16px',
                    border: '1px solid #28a745',
                    backgroundColor: currentPage === 'export' ? '#28a745' : 'white',
                    color: currentPage === 'export' ? 'white' : '#28a745',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Export Data
                </button>
                <button
                  onClick={() => setCurrentPage('admin')}
                  style={{
                    padding: '8px 16px',
                    border: '1px solid #dc3545',
                    backgroundColor: currentPage === 'admin' ? '#dc3545' : 'white',
                    color: currentPage === 'admin' ? 'white' : '#dc3545',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Admin Data Management
                </button>
              </>
            )}
            <button
              onClick={logout}
              style={{
                padding: '8px 16px',
                border: '1px solid #dc3545',
                backgroundColor: '#dc3545',
                color: 'white',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
      
      {currentPage === 'import' && <BulkImportPage userRole={userRole} userClientId={userClientId} />}
      {currentPage === 'duplicated' && (
        <DuplicatedPage userRole={userRole} userClientId={userClientId} />
      )}
      {currentPage === 'export' && userRole === 'admin' && <ExportPage userRole={userRole} userClientId={userClientId} />}
      {currentPage === 'admin' && userRole === 'admin' && <AdminDataManagementPage userRole={userRole} userClientId={userClientId} />}
    </div>
  );
}

export default App;
